export default {
  '@odata.context':
    "https://jellyfish-search.search.windows.net/indexes('magazinecouk-search')/$metadata#docs(PartitionKey,RowKey,Timestamp,breadcrumbCatName,breadcrumbCatUrl,category,category1,category2,category_id,desc,firstDigit,fourDigitCode,id,image,isDelete,level,offerCpa,offerId,offerName,offerPaymentType,offerPrice,offerProductId,offerProductType,offerSave,offerSku,path,price,redirect,sku,term,title,titleToLower,type,url,subCategory,offerNumOfIssues)",
  '@odata.count': 34,
  value: [
    {
      '@search.score': 2.1906672,
      PartitionKey: 'All',
      RowKey: 'p_5748',
      Timestamp: '2022-06-07T11:04:23.386Z',
      breadcrumbCatName: 'Hobbies & Leisure',
      breadcrumbCatUrl: '/hobbies-and-leisure-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'AIR International is the best magazine for modern military and commercial aviation coverage. Brimming with authoritative reporting and a full spectrum',
      firstDigit: 'a',
      fourDigitCode: 'ARK1',
      id: 'p_5748',
      image: '/products/air-international-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.00',
      offerId: 'ARK1',
      offerName: '3 issues for £12.99',
      offerPaymentType: 'DD',
      offerPrice: 13,
      offerProductId: 13897,
      offerProductType: 'PRINT',
      offerSave: 20,
      offerSku: '11879',
      path: null,
      price: 13,
      redirect: '',
      sku: 'AIR International',
      term: '',
      title: 'AIR International',
      titleToLower: 'air international',
      type: 'magazine',
      url: 'magazines/air-international-magazine',
      subCategory: null,
      offerNumOfIssues: 3
    },
    {
      '@search.score': 2.4456859,
      PartitionKey: 'All',
      RowKey: 'p_3275',
      Timestamp: '2022-06-07T11:04:20.875Z',
      breadcrumbCatName: 'Business & Finance',
      breadcrumbCatUrl: '/business-and-finance-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'If you&rsquo;re looking for a stylish second-home or need inspiration for that last minute luxury villa holiday - then dive into the UK&rsquo;s fastes',
      firstDigit: 'a',
      fourDigitCode: 'ABS1',
      id: 'p_3275',
      image: '/products/abode2-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '10.00',
      offerId: 'ABS1',
      offerName: '4 issues for £20.00',
      offerPaymentType: 'CC',
      offerPrice: 20,
      offerProductId: 2398,
      offerProductType: 'PRINT',
      offerSave: 28,
      offerSku: '5140',
      path: null,
      price: 20,
      redirect: '',
      sku: 'Abode2',
      term: 'home',
      title: 'Abode2',
      titleToLower: 'abode2',
      type: 'magazine',
      url: 'magazines/abode-2-magazine',
      subCategory: null,
      offerNumOfIssues: 4
    },
    {
      '@search.score': 3.103946,
      PartitionKey: 'All',
      RowKey: 'p_12442',
      Timestamp: '2022-06-07T11:04:20.827Z',
      breadcrumbCatName: 'Kids',
      breadcrumbCatUrl: '/kids-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Adventure Box MAX&nbsp;takes its readers by the hand to venture onto more sophisticated plot lines.&nbsp;If your child enjoyed AdventureBox magazine, ',
      firstDigit: 'a',
      fourDigitCode: 'ADBM',
      id: 'p_12442',
      image: '/a/b/abm.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '14.00',
      offerId: 'ADBM',
      offerName: '10 issues for £63.00',
      offerPaymentType: 'CC',
      offerPrice: 63,
      offerProductId: 12443,
      offerProductType: 'PRINT',
      offerSave: 6,
      offerSku: '10556',
      path: null,
      price: 63,
      redirect: '',
      sku: 'Adventure Box Max',
      term: 'kids',
      title: 'Adventure Box Max',
      titleToLower: 'adventure box max',
      type: 'magazine',
      url: 'magazines/adventure-box-max-magazine',
      subCategory: null,
      offerNumOfIssues: 10
    },
    {
      '@search.score': 3.3322046,
      PartitionKey: 'All',
      RowKey: 'p_2798',
      Timestamp: '2022-06-07T11:04:20.837Z',
      breadcrumbCatName: 'Kids',
      breadcrumbCatUrl: '/kids-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'AdventureBox keeps your kids entertained while they improve their reading and learn about the world. Every issue of this fun and educational, award-wi',
      firstDigit: 'a',
      fourDigitCode: 'ABB1',
      id: 'p_2798',
      image: '/a/d/adventure_box.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '14.00',
      offerId: 'ABB1',
      offerName: '10 issues for £63.00',
      offerPaymentType: 'CC',
      offerPrice: 63,
      offerProductId: 522,
      offerProductType: 'PRINT',
      offerSave: 6,
      offerSku: '796',
      path: null,
      price: 63,
      redirect: '',
      sku: 'AdventureBox',
      term: 'kids',
      title: 'AdventureBox',
      titleToLower: 'adventurebox',
      type: 'magazine',
      url: 'magazines/adventure-box-magazine',
      subCategory: null,
      offerNumOfIssues: 10
    },
    {
      '@search.score': 2.1906672,
      PartitionKey: 'All',
      RowKey: 'p_5712',
      Timestamp: '2022-06-07T11:04:20.821Z',
      breadcrumbCatName: 'Hobbies & Leisure',
      breadcrumbCatUrl: '/hobbies-and-leisure-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Explore the world of traditional aeromodelling and get inspired to start building your best models yet with AeroModeller magazine. From plans and buil',
      firstDigit: 'a',
      fourDigitCode: 'AMA1',
      id: 'p_5712',
      image: '/products/aeromodeller-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.50',
      offerId: 'AMA1',
      offerName: '12 issues for £66.00',
      offerPaymentType: 'CC',
      offerPrice: 66,
      offerProductId: 5603,
      offerProductType: 'PRINT',
      offerSave: 8,
      offerSku: '7087',
      path: null,
      price: 66,
      redirect: '',
      sku: 'Aero Modeller',
      term: '',
      title: 'Aero Modeller',
      titleToLower: 'aero modeller',
      type: 'magazine',
      url: 'magazines/aero-modeller-magazine',
      subCategory: null,
      offerNumOfIssues: 12
    },
    {
      '@search.score': 2.4456859,
      PartitionKey: 'All',
      RowKey: 'p_6072',
      Timestamp: '2022-06-07T11:04:20.836Z',
      breadcrumbCatName: 'Hobbies & Leisure',
      breadcrumbCatUrl: '/hobbies-and-leisure-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Aeroplane Collectors&rsquo; Archive is a series of bookazines produced by a dedicated team of enthusiasts focusing on groups of aircraft from the hist',
      firstDigit: 'a',
      fourDigitCode: 'AAK1',
      id: 'p_6072',
      image: '/products/aeroplane-collectors-archive-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.00',
      offerId: 'AAK1',
      offerName: '6 issues for £42.93',
      offerPaymentType: 'CC',
      offerPrice: 43,
      offerProductId: 6000,
      offerProductType: 'PRINT',
      offerSave: 10,
      offerSku: '7160',
      path: null,
      price: 43,
      redirect: '',
      sku: 'Aeroplane Collectors Archive',
      term: '',
      title: 'Aeroplane Collectors Archive',
      titleToLower: 'aeroplane collectors archive',
      type: 'magazine',
      url: 'magazines/aeroplane-collectors-archive-magazine',
      subCategory: null,
      offerNumOfIssues: 6
    },
    {
      '@search.score': 3.9765618,
      PartitionKey: 'All',
      RowKey: 'p_2950',
      Timestamp: '2022-06-07T11:04:21.797Z',
      breadcrumbCatName: 'Hobbies & Leisure',
      breadcrumbCatUrl: '/hobbies-and-leisure-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Aeroplane Monthly is a magazine dedicated to offering the most in-depth and entertaining read on historical aircraft throughout history. With a focus ',
      firstDigit: 'a',
      fourDigitCode: 'AEK1',
      id: 'p_2950',
      image: '/products/aeroplane-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.00',
      offerId: 'AEK1',
      offerName: '3 issues for £12.99',
      offerPaymentType: 'DD',
      offerPrice: 13,
      offerProductId: 13892,
      offerProductType: 'PRINT',
      offerSave: 21,
      offerSku: '11874',
      path: null,
      price: 13,
      redirect: '',
      sku: 'Aeroplane Monthly',
      term: '',
      title: 'Aeroplane Monthly',
      titleToLower: 'aeroplane monthly',
      type: 'magazine',
      url: 'magazines/aeroplane-monthly-magazine',
      subCategory: null,
      offerNumOfIssues: 3
    },
    {
      '@search.score': 2.1906672,
      PartitionKey: 'All',
      RowKey: 'p_5752',
      Timestamp: '2022-06-07T11:04:23.437Z',
      breadcrumbCatName: 'Hobbies & Leisure',
      breadcrumbCatUrl: '/hobbies-and-leisure-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Seeking a well-informed view of modern military aircraft and their air arms? AirForces Monthly is an essential read for those who are interested in st',
      firstDigit: 'a',
      fourDigitCode: 'AOF1',
      id: 'p_5752',
      image: '/products/airforces-monthly-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.00',
      offerId: 'AOF1',
      offerName: '3 issues for £12.99',
      offerPaymentType: 'DD',
      offerPrice: 13,
      offerProductId: 13896,
      offerProductType: 'PRINT',
      offerSave: 21,
      offerSku: '11878',
      path: null,
      price: 13,
      redirect: '',
      sku: 'AirForces Monthly',
      term: '',
      title: 'AirForces Monthly',
      titleToLower: 'airforces monthly',
      type: 'magazine',
      url: 'magazines/airforces-monthly-magazine',
      subCategory: null,
      offerNumOfIssues: 3
    },
    {
      '@search.score': 2.4456859,
      PartitionKey: 'All',
      RowKey: 'p_6907',
      Timestamp: '2022-06-07T11:04:23.383Z',
      breadcrumbCatName: 'Arts & Culture',
      breadcrumbCatUrl: '/arts-and-culture-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Airbrush Step by Step is the magazine for all airbrush artists: from beginner to advanced level, both classical airbrushers and plastic scale modeller',
      firstDigit: 'a',
      fourDigitCode: 'ASN1',
      id: 'p_6907',
      image: '/products/airbrush-step-by-step-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '12.00',
      offerId: 'ASN1',
      offerName: '4 issues for £32.50',
      offerPaymentType: 'CC',
      offerPrice: 32,
      offerProductId: 6911,
      offerProductType: 'PRINT',
      offerSave: 0,
      offerSku: '7339',
      path: null,
      price: 32,
      redirect: '',
      sku: 'Airbrush Step by Step',
      term: 'craft art',
      title: 'Airbrush Step by Step',
      titleToLower: 'airbrush step by step',
      type: 'magazine',
      url: 'magazines/airbrush-step-by-step-magazine',
      subCategory: null,
      offerNumOfIssues: 4
    },
    {
      '@search.score': 3.103946,
      PartitionKey: 'All',
      RowKey: 'p_2754',
      Timestamp: '2022-06-07T11:04:21.116Z',
      breadcrumbCatName: 'Hobbies & Leisure',
      breadcrumbCatUrl: '/hobbies-and-leisure-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Whether you&rsquo;re an eager novice or an experienced master modeller, Airfix Model World is your complete guide to the world of scale modelling. Eac',
      firstDigit: 'a',
      fourDigitCode: 'AFK1',
      id: 'p_2754',
      image: '/products/airfix-model-world-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.00',
      offerId: 'AFK1',
      offerName: '3 issues for £12.99',
      offerPaymentType: 'DD',
      offerPrice: 13,
      offerProductId: 13893,
      offerProductType: 'PRINT',
      offerSave: 18,
      offerSku: '11875',
      path: null,
      price: 13,
      redirect: '',
      sku: 'Airfix Model World',
      term: '',
      title: 'Airfix Model World',
      titleToLower: 'airfix model world',
      type: 'magazine',
      url: 'magazines/airfix-model-world-magazine',
      subCategory: null,
      offerNumOfIssues: 3
    },
    {
      '@search.score': 2.1906672,
      PartitionKey: 'All',
      RowKey: 'p_2815',
      Timestamp: '2022-06-07T11:04:21.27Z',
      breadcrumbCatName: 'Sports',
      breadcrumbCatUrl: '/sports-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Airgun Shooter is the UK&rsquo;s top magazine for airgunners.&nbsp; Filled with the latest news, reviews and techniques to help you get the most out o',
      firstDigit: 'a',
      fourDigitCode: 'BAIR',
      id: 'p_2815',
      image: '/products/airgun-shooter-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.50',
      offerId: 'BAIR',
      offerName: '6 issues for £26.00',
      offerPaymentType: 'DD',
      offerPrice: 26,
      offerProductId: 10032,
      offerProductType: 'PRINT',
      offerSave: 13,
      offerSku: '8255',
      path: null,
      price: 26,
      redirect: '',
      sku: 'Airgun Shooter',
      term: '',
      title: 'Airgun Shooter',
      titleToLower: 'airgun shooter',
      type: 'magazine',
      url: 'magazines/airgun-shooter-magazine',
      subCategory: null,
      offerNumOfIssues: 6
    },
    {
      '@search.score': 3.0513022,
      PartitionKey: 'All',
      RowKey: 'p_5756',
      Timestamp: '2022-06-07T11:04:22.97Z',
      breadcrumbCatName: 'Industry & Trade',
      breadcrumbCatUrl: '/industry-and-trade-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Interested in the latest developments across the global aviation scene? Satisfy all your curiosities for aeronautics and interests in aviation with a ',
      firstDigit: 'a',
      fourDigitCode: 'AIK1',
      id: 'p_5756',
      image: '/products/airliner-world-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.00',
      offerId: 'AIK1',
      offerName: '3 issues for £12.99',
      offerPaymentType: 'DD',
      offerPrice: 13,
      offerProductId: 13894,
      offerProductType: 'PRINT',
      offerSave: 23,
      offerSku: '11876',
      path: null,
      price: 13,
      redirect: '',
      sku: 'Airliner World',
      term: '',
      title: 'Airliner World',
      titleToLower: 'airliner world',
      type: 'magazine',
      url: 'magazines/airliner-world-magazine',
      subCategory: null,
      offerNumOfIssues: 3
    },
    {
      '@search.score': 3.4446826,
      PartitionKey: 'All',
      RowKey: 'p_2792',
      Timestamp: '2022-06-07T11:04:21.071Z',
      breadcrumbCatName: 'Arts & Culture',
      breadcrumbCatUrl: '/arts-and-culture-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'History lovers of all ages will love the fascinating features on legends, empires and historical eras with an All About History magazine subscription!',
      firstDigit: 'a',
      fourDigitCode: 'AHI1',
      id: 'p_2792',
      image: '/products/all-about-history-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.50',
      offerId: 'AHI1',
      offerName: '6 issues for £25.75',
      offerPaymentType: 'DD',
      offerPrice: 26,
      offerProductId: 4213,
      offerProductType: 'PRINT',
      offerSave: 22,
      offerSku: '5460',
      path: null,
      price: 26,
      redirect: '',
      sku: 'All About History',
      term: 'history',
      title: 'All About History',
      titleToLower: 'all about history',
      type: 'magazine',
      url: 'magazines/all-about-history-magazine',
      subCategory: null,
      offerNumOfIssues: 6
    },
    {
      '@search.score': 3.1267605,
      PartitionKey: 'All',
      RowKey: 'p_3089',
      Timestamp: '2022-06-07T11:04:21.398Z',
      breadcrumbCatName: 'Computers & Technology',
      breadcrumbCatUrl: '/computers-and-technology-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Always looking beyond the stars? Come back down to earth and find incredible facts and features with an All About Space magazine subscription. Written',
      firstDigit: 'a',
      fourDigitCode: 'AAI1',
      id: 'p_3089',
      image: '/products/all-about-space-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.50',
      offerId: 'AAI1',
      offerName: '6 issues for £25.75',
      offerPaymentType: 'DD',
      offerPrice: 26,
      offerProductId: 2501,
      offerProductType: 'PRINT',
      offerSave: 22,
      offerSku: '5011',
      path: null,
      price: 26,
      redirect: '',
      sku: 'All About Space',
      term: 'science',
      title: 'All About Space',
      titleToLower: 'all about space',
      type: 'magazine',
      url: 'magazines/all-about-space-magazine',
      subCategory: null,
      offerNumOfIssues: 6
    },
    {
      '@search.score': 3.0239031,
      PartitionKey: 'All',
      RowKey: 'p_2770',
      Timestamp: '2022-06-07T11:04:21.306Z',
      breadcrumbCatName: 'Home & Gardening',
      breadcrumbCatUrl: '/hobbies-and-leisure-magazines/home-and-gardening',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'On a bid to make your garden blooming beautiful? Grab those gardening gloves and an Amateur Gardening magazine subscription, the UK&rsquo;s best-selli',
      firstDigit: 'a',
      fourDigitCode: 'AGI1',
      id: 'p_2770',
      image: '/products/amateur-gardening-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.50',
      offerId: 'AGI1',
      offerName: '12 issues for £21.75',
      offerPaymentType: 'DD',
      offerPrice: 22,
      offerProductId: 1332,
      offerProductType: 'PRINT',
      offerSave: 14,
      offerSku: '2968',
      path: null,
      price: 22,
      redirect: '',
      sku: 'Amateur Gardening',
      term: '',
      title: 'Amateur Gardening',
      titleToLower: 'amateur gardening',
      type: 'magazine',
      url: 'magazines/amateur-gardening-magazine',
      subCategory: null,
      offerNumOfIssues: 12
    },
    {
      '@search.score': 2.4456859,
      PartitionKey: 'All',
      RowKey: 'p_3193',
      Timestamp: '2022-06-08T13:45:19.458Z',
      breadcrumbCatName: 'Computers & Technology',
      breadcrumbCatUrl: '/computers-and-technology-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Subscribe to Amateur Photographer magazine today for a weekly magazine that is specifically designed to educate and excite up-and-coming photographers',
      firstDigit: 'a',
      fourDigitCode: 'API1',
      id: 'p_3193',
      image: '/products/amateur-photographer-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '12.50',
      offerId: 'API1',
      offerName: '13 issues for £27.99',
      offerPaymentType: 'DD',
      offerPrice: 28,
      offerProductId: 14127,
      offerProductType: 'PRINT',
      offerSave: 43,
      offerSku: '12090',
      path: null,
      price: 28,
      redirect: '',
      sku: 'Amateur Photographer',
      term: 'photography',
      title: 'Amateur Photographer',
      titleToLower: 'amateur photographer',
      type: 'magazine',
      url: 'magazines/amateur-photographer-magazine',
      subCategory: null,
      offerNumOfIssues: 13
    },
    {
      '@search.score': 2.8415816,
      PartitionKey: 'All',
      RowKey: 'p_13388',
      Timestamp: '2022-06-07T11:04:21.31Z',
      breadcrumbCatName: 'Food & Drink',
      breadcrumbCatUrl: '/food-and-drink-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Welcome to the world of bourbon, rye and even single malts. Subscribe to American Whiskey Magazine and discover America&rsquo;s amazing adventure into',
      firstDigit: 'a',
      fourDigitCode: 'AWHI',
      id: 'p_13388',
      image: '/products/american-whiskey-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: null,
      offerId: null,
      offerName: null,
      offerPaymentType: null,
      offerPrice: null,
      offerProductId: null,
      offerProductType: null,
      offerSave: null,
      offerSku: null,
      path: null,
      price: null,
      redirect: '',
      sku: 'American Whiskey',
      term: 'whisky food',
      title: 'American Whiskey',
      titleToLower: 'american whiskey',
      type: 'magazine',
      url: 'magazines/american-whiskey-magazine',
      subCategory: null,
      offerNumOfIssues: null
    },
    {
      '@search.score': 3.0513022,
      PartitionKey: 'All',
      RowKey: 'p_13829',
      Timestamp: '2022-06-07T11:04:21.692Z',
      breadcrumbCatName: 'History',
      breadcrumbCatUrl: '/hobbies-and-leisure-magazines/history',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Ancient History looks at every aspect of the ancient world: you&#39;ll find articles covering politics, society, literature, language, religion, econo',
      firstDigit: 'a',
      fourDigitCode: 'ANH1',
      id: 'p_13829',
      image: '/products/ancient-history-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '15.00',
      offerId: 'ANH1',
      offerName: '6 issues for £42.99',
      offerPaymentType: 'CC',
      offerPrice: 43,
      offerProductId: 13833,
      offerProductType: 'PRINT',
      offerSave: 0,
      offerSku: '11816',
      path: null,
      price: 43,
      redirect: '',
      sku: 'Ancient History',
      term: '',
      title: 'Ancient History',
      titleToLower: 'ancient history',
      type: 'magazine',
      url: 'magazines/ancient-history-magazine',
      subCategory: null,
      offerNumOfIssues: 6
    },
    {
      '@search.score': 3.0239031,
      PartitionKey: 'All',
      RowKey: 'p_13830',
      Timestamp: '2022-06-07T11:04:23.625Z',
      breadcrumbCatName: 'History',
      breadcrumbCatUrl: '/hobbies-and-leisure-magazines/history',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Ancient Warfare is a unique publication focused exclusively on soldiers, battles, and tactics, all before 600 AD. Starting with ancient Egypt and Pers',
      firstDigit: 'a',
      fourDigitCode: 'ANW1',
      id: 'p_13830',
      image: '/products/ancient-warfare-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '15.00',
      offerId: 'ANW1',
      offerName: '6 issues for £42.99',
      offerPaymentType: 'CC',
      offerPrice: 43,
      offerProductId: 13836,
      offerProductType: 'PRINT',
      offerSave: 0,
      offerSku: '11819',
      path: null,
      price: 43,
      redirect: '',
      sku: 'Ancient Warfare',
      term: '',
      title: 'Ancient Warfare',
      titleToLower: 'ancient warfare',
      type: 'magazine',
      url: 'magazines/ancient-warfare-magazine',
      subCategory: null,
      offerNumOfIssues: 6
    },
    {
      '@search.score': 3.3322046,
      PartitionKey: 'All',
      RowKey: 'p_2801',
      Timestamp: '2022-06-07T11:04:21.6Z',
      breadcrumbCatName: 'Sports',
      breadcrumbCatUrl: '/sports-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Britain&rsquo;s bestselling weekly magazine for anglers, Angling Times shares expert tips and advice, the best gear, as well as current issues facing ',
      firstDigit: 'a',
      fourDigitCode: 'ATB1',
      id: 'p_2801',
      image: '/products/angling-times-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '10.00',
      offerId: 'ATB1',
      offerName: '52 issues for £111.00',
      offerPaymentType: 'DD',
      offerPrice: 111,
      offerProductId: 3835,
      offerProductType: 'PRINT',
      offerSave: 15,
      offerSku: '5393',
      path: null,
      price: 111,
      redirect: '',
      sku: 'Angling Times',
      term: 'fishing',
      title: 'Angling Times',
      titleToLower: 'angling times',
      type: 'magazine',
      url: 'magazines/angling-times-magazine',
      subCategory: null,
      offerNumOfIssues: 52
    },
    {
      '@search.score': 3.1945832,
      PartitionKey: 'All',
      RowKey: 'p_13484',
      Timestamp: '2022-06-07T11:04:23.689Z',
      breadcrumbCatName: 'Nature & Wildlife',
      breadcrumbCatUrl: '/science-and-nature-magazines/nature-and-wildlife',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'An Animal Planet magazine subscription opens up a world of big ideas just waiting to be discovered. Packed with curious creatures and awe-inspiring na',
      firstDigit: 'a',
      fourDigitCode: 'ANPL',
      id: 'p_13484',
      image: '/products/animal-planet-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '11.00',
      offerId: 'ANPL',
      offerName: '3 issues for £9.95',
      offerPaymentType: 'DD',
      offerPrice: 10,
      offerProductId: 13503,
      offerProductType: 'PRINT',
      offerSave: 17,
      offerSku: '11524',
      path: null,
      price: 10,
      redirect: '',
      sku: 'Animal Planet',
      term: 'kids',
      title: 'Animal Planet',
      titleToLower: 'animal planet',
      type: 'magazine',
      url: 'magazines/animal-planet-magazine',
      subCategory: null,
      offerNumOfIssues: 3
    },
    {
      '@search.score': 2.1906672,
      PartitionKey: 'All',
      RowKey: 'p_14114',
      Timestamp: '2022-06-08T13:20:17.791Z',
      breadcrumbCatName: 'Nature & Wildlife',
      breadcrumbCatUrl: '/science-and-nature-magazines/nature-and-wildlife',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Animal Wise is part of the Quokka Box subscription, a fun, monthly letterbox subscription that teaches children how to respect and live in harmony wit',
      firstDigit: 'a',
      fourDigitCode: 'ANWI',
      id: 'p_14114',
      image: '/a/n/animal_wise.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '15.00',
      offerId: 'ANWI',
      offerName: '1 issue for £7.99',
      offerPaymentType: 'DD',
      offerPrice: 8,
      offerProductId: 14115,
      offerProductType: 'PRINT',
      offerSave: 0,
      offerSku: '12079',
      path: null,
      price: 8,
      redirect: '',
      sku: 'Animal Wise',
      term: '',
      title: 'Animal Wise',
      titleToLower: 'animal wise',
      type: 'magazine',
      url: 'magazines/animal-wise-magazine',
      subCategory: null,
      offerNumOfIssues: 1
    },
    {
      '@search.score': 3.6198866,
      PartitionKey: 'All',
      RowKey: 'p_3292',
      Timestamp: '2022-06-07T11:04:21.706Z',
      breadcrumbCatName: 'Kids',
      breadcrumbCatUrl: '/kids-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Animals and You is the perfect magazine gift subscription for girls who love animals! Each issue is packed full of super sweet pets and adorable wild ',
      firstDigit: 'a',
      fourDigitCode: 'AYD1',
      id: 'p_3292',
      image: '/a/n/animals-and-you-magazine_15.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '11.00',
      offerId: 'AYD1',
      offerName: '3 issues for £15.00',
      offerPaymentType: 'DD',
      offerPrice: 15,
      offerProductId: 13422,
      offerProductType: 'PRINT',
      offerSave: 0,
      offerSku: '11449',
      path: null,
      price: 15,
      redirect: '',
      sku: 'Animals & You',
      term: 'kids',
      title: 'Animals & You',
      titleToLower: 'animals & you',
      type: 'magazine',
      url: 'magazines/animals-and-you-magazine',
      subCategory: null,
      offerNumOfIssues: 3
    },
    {
      '@search.score': 3.1267605,
      PartitionKey: 'All',
      RowKey: 'p_10364',
      Timestamp: '2022-06-07T11:04:23.512Z',
      breadcrumbCatName: 'Arts & Culture',
      breadcrumbCatUrl: '/arts-and-culture-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Dedicated to serving the art and antiques community through unrivalled news coverage and analysis, Antiques Trade Gazette boasts a long tradition of a',
      firstDigit: 'a',
      fourDigitCode: 'ATG1',
      id: 'p_10364',
      image: '/products/antiques-trade-gazette-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '35.00',
      offerId: 'ATG1',
      offerName: '12 issues for £39.75',
      offerPaymentType: 'DD',
      offerPrice: 40,
      offerProductId: 11008,
      offerProductType: 'PRINT',
      offerSave: 34,
      offerSku: '9074',
      path: null,
      price: 40,
      redirect: '',
      sku: 'Antiques Trade Gazette',
      term: '',
      title: 'Antiques Trade Gazette',
      titleToLower: 'antiques trade gazette',
      type: 'magazine',
      url: 'magazines/antiques-trade-gazette-magazine',
      subCategory: null,
      offerNumOfIssues: 12
    },
    {
      '@search.score': 3.4446826,
      PartitionKey: 'All',
      RowKey: 'p_2641',
      Timestamp: '2022-06-07T11:04:22.624Z',
      breadcrumbCatName: 'Arts & Culture',
      breadcrumbCatUrl: '/arts-and-culture-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Apollo magazine is a spectacular, sophisticated and sensational read delving into the world of art. With more than 90 years of experience, Apollo is a',
      firstDigit: 'a',
      fourDigitCode: 'PAPO',
      id: 'p_2641',
      image: '/a/p/apollo_1.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '14.00',
      offerId: 'PAPO',
      offerName: '3 issues for £5.00',
      offerPaymentType: 'DD',
      offerPrice: 5,
      offerProductId: 494,
      offerProductType: 'PRINT',
      offerSave: 79,
      offerSku: '1175',
      path: null,
      price: 5,
      redirect: '',
      sku: 'Apollo',
      term: '',
      title: 'Apollo',
      titleToLower: 'apollo',
      type: 'magazine',
      url: 'magazines/apollo-magazine',
      subCategory: null,
      offerNumOfIssues: 3
    },
    {
      '@search.score': 2.8415816,
      PartitionKey: 'All',
      RowKey: 'p_2907',
      Timestamp: '2022-06-07T11:04:21.579Z',
      breadcrumbCatName: 'Arts & Culture',
      breadcrumbCatUrl: '/arts-and-culture-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Ideal for both experienced and budding artists, Artists &amp; Illustrators magazine provides inspiration and creativity throughout every edition, givi',
      firstDigit: 'a',
      fourDigitCode: 'CHAI',
      id: 'p_2907',
      image: '/products/artist-and-illustrators-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '15.00',
      offerId: 'CHAI',
      offerName: '6 issues for £17.99',
      offerPaymentType: 'DD',
      offerPrice: 18,
      offerProductId: 1392,
      offerProductType: 'PRINT',
      offerSave: 39,
      offerSku: '3094',
      path: null,
      price: 18,
      redirect: '',
      sku: 'Artists and Illustrators',
      term: 'craft art',
      title: 'Artists and Illustrators',
      titleToLower: 'artists and illustrators',
      type: 'magazine',
      url: 'magazines/artists-and-illustrators-magazine',
      subCategory: null,
      offerNumOfIssues: 6
    },
    {
      '@search.score': 2.4456859,
      PartitionKey: 'All',
      RowKey: 'p_14119',
      Timestamp: '2022-06-07T11:04:25.036Z',
      breadcrumbCatName: 'Cars',
      breadcrumbCatUrl: '/motoring-and-transport-magazines/cars',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Aston Martin was once voted the world&rsquo;s coolest brand. The British car maker has been synonymous with style, prestige and performance for almost',
      firstDigit: 'a',
      fourDigitCode: 'AMD1',
      id: 'p_14119',
      image: '/a/m/amd.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '12.50',
      offerId: 'AMD1',
      offerName: '4 issues for £22.96',
      offerPaymentType: 'DD',
      offerPrice: 23,
      offerProductId: 14120,
      offerProductType: 'PRINT',
      offerSave: 4,
      offerSku: '12083',
      path: null,
      price: 23,
      redirect: '',
      sku: 'Aston Martin Driver',
      term: '',
      title: 'Aston Martin Driver',
      titleToLower: 'aston martin driver',
      type: 'magazine',
      url: 'magazines/aston-martin-driver-magazine',
      subCategory: null,
      offerNumOfIssues: 4
    },
    {
      '@search.score': 3.1945832,
      PartitionKey: 'All',
      RowKey: 'p_3251',
      Timestamp: '2022-06-07T11:04:22.335Z',
      breadcrumbCatName: 'Sports',
      breadcrumbCatUrl: '/sports-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Crazy about cross-country? Training for track and field? An Athletics Weekly magazine subscription is ideal for anyone interested in the world of athl',
      firstDigit: 'a',
      fourDigitCode: 'ATHL',
      id: 'p_3251',
      image: '/products/athletics-weekly-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '15.00',
      offerId: 'ATHL',
      offerName: '1 issue for £9.99',
      offerPaymentType: 'DD',
      offerPrice: 10,
      offerProductId: 123,
      offerProductType: 'PRINT',
      offerSave: 0,
      offerSku: '1547',
      path: null,
      price: 10,
      redirect: '',
      sku: 'Athletics Weekly',
      term: 'AW',
      title: 'Athletics Weekly',
      titleToLower: 'athletics weekly',
      type: 'magazine',
      url: 'magazines/athletics-weekly-magazine',
      subCategory: null,
      offerNumOfIssues: 1
    },
    {
      '@search.score': 2.1906672,
      PartitionKey: 'All',
      RowKey: 'p_2818',
      Timestamp: '2022-06-07T11:04:23.926Z',
      breadcrumbCatName: 'Lifestyle',
      breadcrumbCatUrl: '/lifestyle-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'An attitude magazine subscription brings you exclusive and revealing celebrity interviews, smokin&#39; hot men, impactful fitness tips, avant-garde fa',
      firstDigit: 'a',
      fourDigitCode: 'ATA1',
      id: 'p_2818',
      image: '/products/attitude-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '10.00',
      offerId: 'ATA1',
      offerName: '3 issues for £18.00',
      offerPaymentType: 'CC',
      offerPrice: 18,
      offerProductId: 2274,
      offerProductType: 'PRINT',
      offerSave: 0,
      offerSku: '4654',
      path: null,
      price: 18,
      redirect: '',
      sku: 'Attitude',
      term: '',
      title: 'Attitude',
      titleToLower: 'attitude',
      type: 'magazine',
      url: 'magazines/attitude-magazine',
      subCategory: null,
      offerNumOfIssues: 3
    },
    {
      '@search.score': 3.103946,
      PartitionKey: 'All',
      RowKey: 'p_2637',
      Timestamp: '2022-06-07T11:04:24.249Z',
      breadcrumbCatName: 'Computers & Technology',
      breadcrumbCatUrl: '/computers-and-technology-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Subscribe to Audio Visual magazine today; one of the most enthralling and informative technology guides on the market.A subscription to this magnifice',
      firstDigit: 'a',
      fourDigitCode: 'MGAV',
      id: 'p_2637',
      image: '/a/u/audio-visual-magazine_2.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '15.00',
      offerId: 'MGAV',
      offerName: '7 issues for £76.50',
      offerPaymentType: 'CC',
      offerPrice: 76,
      offerProductId: 848,
      offerProductType: 'PRINT',
      offerSave: 10,
      offerSku: '1683',
      path: null,
      price: 76,
      redirect: '',
      sku: 'Audio Visual',
      term: '',
      title: 'Audio Visual',
      titleToLower: 'audio visual',
      type: 'magazine',
      url: 'magazines/audio-visual-magazine',
      subCategory: null,
      offerNumOfIssues: 7
    },
    {
      '@search.score': 3.0513022,
      PartitionKey: 'All',
      RowKey: 'p_3158',
      Timestamp: '2022-06-07T11:04:22.06Z',
      breadcrumbCatName: 'Motoring & Transport',
      breadcrumbCatUrl: '/motoring-and-transport-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Need to know the latest up-to-the-minute car news and exclusives? Thinking of swapping your old banger for something shinier? An Auto Express magazine',
      firstDigit: 'a',
      fourDigitCode: 'AED1',
      id: 'p_3158',
      image: '/products/auto-express-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '8.50',
      offerId: 'AED1',
      offerName: '6 issues for £1.00',
      offerPaymentType: 'DD',
      offerPrice: 1,
      offerProductId: 499,
      offerProductType: 'PRINT',
      offerSave: 95,
      offerSku: '1759',
      path: null,
      price: 1,
      redirect: '',
      sku: 'Auto Express',
      term: 'cars',
      title: 'Auto Express',
      titleToLower: 'auto express',
      type: 'magazine',
      url: 'magazines/auto-express-magazine',
      subCategory: null,
      offerNumOfIssues: 6
    },
    {
      '@search.score': 2.8415816,
      PartitionKey: 'All',
      RowKey: 'p_3004',
      Timestamp: '2022-06-07T11:04:21.935Z',
      breadcrumbCatName: 'Motoring & Transport',
      breadcrumbCatUrl: '/motoring-and-transport-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'For more than 125 years, Autocar has been the magazine of choice for all car fans. An Autocar magazine subscription gives you access to the latest new',
      firstDigit: 'a',
      fourDigitCode: 'HAUM',
      id: 'p_3004',
      image: '/products/autocar-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '14.50',
      offerId: 'HAUM',
      offerName: '6 issues for £1.00',
      offerPaymentType: 'DD',
      offerPrice: 1,
      offerProductId: 3384,
      offerProductType: 'PRINT',
      offerSave: 96,
      offerSku: '5314',
      path: null,
      price: 1,
      redirect: '',
      sku: 'Autocar',
      term: 'cars',
      title: 'Autocar',
      titleToLower: 'autocar',
      type: 'magazine',
      url: 'magazines/autocar-magazine',
      subCategory: null,
      offerNumOfIssues: 6
    },
    {
      '@search.score': 3.0239031,
      PartitionKey: 'All',
      RowKey: 'p_2740',
      Timestamp: '2022-06-07T11:04:22.881Z',
      breadcrumbCatName: 'Motoring & Transport',
      breadcrumbCatUrl: '/motoring-and-transport-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Autosport delivers you the hottest weekly motor racing and Formula 1 news, analysis and commentary.Autosport brings you full race reports, post race a',
      firstDigit: 'a',
      fourDigitCode: 'HAUT',
      id: 'p_2740',
      image: '/products/autosport-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '14.00',
      offerId: 'HAUT',
      offerName: '5 issues for £5.00',
      offerPaymentType: 'DD',
      offerPrice: 5,
      offerProductId: 101,
      offerProductType: 'PRINT',
      offerSave: 84,
      offerSku: '1867',
      path: null,
      price: 5,
      redirect: '',
      sku: 'Autosport',
      term: '',
      title: 'Autosport',
      titleToLower: 'autosport',
      type: 'magazine',
      url: 'magazines/autosport-magazine',
      subCategory: null,
      offerNumOfIssues: 5
    },
    {
      '@search.score': 2.1906672,
      PartitionKey: 'All',
      RowKey: 'p_6060',
      Timestamp: '2022-06-07T11:04:21.804Z',
      breadcrumbCatName: 'Hobbies & Leisure',
      breadcrumbCatUrl: '/hobbies-and-leisure-magazines',
      category: null,
      category1: null,
      category2: null,
      category_id: null,
      desc: 'Explore the past, present and future of flight with Aviation News magazine. Jam-packed with exciting features, this magazine covers every branch of av',
      firstDigit: 'a',
      fourDigitCode: 'ANK1',
      id: 'p_6060',
      image: '/products/aviation-news-magazine-cover.jpg',
      isDelete: 0,
      level: null,
      offerCpa: '13.00',
      offerId: 'ANK1',
      offerName: '3 issues for £12.99',
      offerPaymentType: 'DD',
      offerPrice: 13,
      offerProductId: 13895,
      offerProductType: 'PRINT',
      offerSave: 21,
      offerSku: '11877',
      path: null,
      price: 13,
      redirect: '',
      sku: 'Aviation News',
      term: '',
      title: 'Aviation News',
      titleToLower: 'aviation news',
      type: 'magazine',
      url: 'magazines/aviation-news-magazine',
      subCategory: null,
      offerNumOfIssues: 3
    }
  ]
}
